import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';
import moment from 'moment';

class ContraRecibo extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'contra-recibo/one', saveUrl: 'contra-recibo/save', backUrl: 'jfhdfs' },
      new Form([
        Form.Field('radio', 'reporte', 'Reporte', '', [Validators.required], 12, [
          { Label: 'Reporte de Estado de Cuenta', Value: 1 },
          { Label: 'Reporte de Movimientos del Cliente', Value: 2 },
          { Label: 'Reporte de Cobranza Detallada', Value: 3 },
          { Label: 'Reporte de Cobranza Global.', Value: 4 },
        ]),
        Form.Field('select', 'id_ejecutivo', 'Ejecutivo', '', [Validators.required], 4),
        Form.Field('autocomplete', 'id_cliente', 'Cliente', '', [Validators.required], 4),
        Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 4),
        Form.Field('select', 'id_plazo', 'Tipo', '', [Validators.required], 2, [
          { Value: 0, Label: 'Ambas' },
          { Value: 1, Label: 'Contado' },
          { Value: 2, Label: 'Crédito' },
        ]),
        Form.Field('date', 'inicio', 'Inicio', false, [Validators.required], 5),
        Form.Field('date', 'fin', 'Fin', false, [Validators.required], 5),
        Form.Field('number', 'plazo1', 'Plazo 1', 15, [], 2),
        Form.Field('number', 'plazo2', 'Plazo 2', 30, [], 2),
        Form.Field('number', 'plazo3', 'Plazo 3', 60, [], 2),
        Form.Field('number', 'plazo4', 'Plazo 4', 90, [], 2),
        Form.Field('number', 'plazo5', 'Plazo 5', 120, [], 2),
        Form.Field('number', 'plazo6', 'Plazo 6', 150, [], 2),
      ], ['Reporte'], 'Reportes'), this.formData
    )

    // this.LoadPreds(this.props.factura.id, false);
  }

  formData = async (form, cli = null) => {
    let query = ``;
    if (cli) query = `c=${cli}`;
    let newForm = form;
    let Res = await Http.get('reporte-cobranza/reporte/form?' + query);
    console.log(Res);
    if (!Res.error) {
      newForm = Form.FieldOptions(form, 'id_sucursal', [{ id: 0, sucursal_nombre: 'Cualquiera' }, ...Res.data.sucursales], 'id', 'sucursal_nombre');
      newForm = Form.FieldOptions(form, 'id_ejecutivo', [{ id: 0, ejecutivo_nombre: 'Cualquiera' }, ...Res.data.ejecutivos], 'id', 'ejecutivo_nombre');
      Res.data.clientes = Res.data.clientes ? [{ id: 0, cliente_completo: 'Cualquiera' }, ...Res.data.clientes] : [{ id: 0, cliente_completo: 'Cualquiera' }];
      newForm = Form.FieldOptions(form, 'id_cliente', Res.data.clientes, 'id', 'cliente_completo');
    }
    newForm = Form.ValueChange(newForm, {
      id_cliente: this.clienteChange
    })
    return newForm;
  }

  clienteChange = async (field, a) => {
    // console.log(field, a)
    const { Value, ValueAt } = field;
    if (!Value || Value.length < 1) {
      if (ValueAt.length > 2)
        this.setState({ FormData: await this.formData(this.state.FormData, ValueAt) });
    }
    else {
      console.log(Value)
    }
  }

  onSubmit = async (button, vals) => {
    this.setState({ loading: true });
    const inicio = moment(vals.inicio).format('YYYY-MM-DD');
    const fin = moment(vals.fin).format('YYYY-MM-DD');
    let params = {
      ...vals,
      inicio,
      fin,
    }

    try {
      let Res = await Http.get(`reporte-cobranza/reporte?${objectAsParams(params)}`, true, 'arraybuffer');

      if (Res) {
        const blob = new Blob([Res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'ReporteCobranza.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      // if (!Res.error) {

      // }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ContraRecibo)
